//import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const SubjobEditModel = {
    headerTitle: i18n.t("servicesystem.common_objects.machine.machine"),
    enabledIcon: "miscellaneous_services",
    disabledIcon: "miscellaneous_services",
    listItemTextKey: "Machine.DisplayName",

    fields: [
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.name"), valuekey: "Machine.DisplayName", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.machine.model"), valuekey: "Machine.MachineModel.DisplayName", editable: true, rules: "", defaultValue: "" },
        { type: "area", label: i18n.t("servicesystem.common_objects.machine.edit.customer_comment"), valuekey: "CustomerComment", editable: true, rules: "", defaultValue: "" },
        { type: "area", label: i18n.t("servicesystem.common_objects.machine.edit.invoice_comment"), valuekey: "InvoiceComment", editable: true, rules: "", defaultValue: "" },
        { type: "input", label: i18n.t("servicesystem.common_objects.job.job_category"), valuekey: "JobCategory.Name", editable: true, rules: "", defaultValue: "" },
        { type: "switch", label: i18n.t("servicesystem.common_objects.machine.service_agreement"), valuekey: "Machine.ServiceAgreement", editable: true, rules: "", defaultValue: "" },
        //{ type: "area", label: i18n.t("servicesystem.common_objects.machine.edit.technician_comment"), valuekey: "TechnicianComment", editable: true, rules: "", defaultValue: "" },
    ],

    methods: {

    }
}

export default SubjobEditModel;